import React from "react";
import "./Info.css";
const Info = () => {
  return (
    <div className="info" style={{ backgroundColor: "#b9f5a0" }}>
      <div className="heading-container">
       
        <div className="heading-line"></div>
        <span>Day 5</span>
        <div className="heading">Environmental Commitment, A Pledge for a Greener Future! </div>
      </div>
      <div className="text1">
      On the final day of our Environment Day event, we aim to create a lasting impact through meaningful
discussions and actionable steps
      </div>
      <div className="text2">
      The honourable director will initiate the day by administering a pledge to make a positive change and
then recognizing students who won the E-slogan and E-poster competitions as well as the volunteers
whose hard efforts led to the smooth and successful completion of the event
      </div>
      <div className="text2">
      Lastly, We'll have two honourable professors, Prof Mahesh Shindikar and Prof Parag Sadgir, with a
thought-provoking talk on "Sustainable Development Gateway for a better tomorrow” and
“Decentralized Wastewater System” respectively. Their inspiring speech will remind us of the
intrinsic connection between our inner well-being and the health of our planet and a pledge that will
be initiated by the honourable director sir to make a positive change.
As our Environment Day event comes to a close, let us reflect on the collective efforts made during
these five days and carry forward the lessons learned. By integrating sustainable practices into our
daily lives, we can ensure a greener and healthier future for ourselves and generations to come.

      </div>
      <div className="text2">
      
As our Environment Day event comes to a close, let us reflect on the collective efforts made during
these five days and carry forward the lessons learned. By integrating sustainable practices into our
daily lives, we can ensure a greener and healthier future for ourselves and generations to come.

      </div>
      <div className="extra">
        <div className="date">
          <span style={{ fontWeight: "bold" }}>Date</span>: 5 June, 2023
        </div>
        {/* <div className="time">Time: 4:00 PM</div>
        <div className="location">Venue: Adminsitrative Building</div> */}
      </div>
    </div>
  );
};

export default Info;
